export default function Home() {
  const productCardStyle = {
    flex: "1 1 300px",
    background: "#111",
    border: "1px solid #444",
    borderRadius: "10px",
    padding: "24px",
    textAlign: "left",
  };

  const featureGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "16px",
  };

  const featureChipStyle = {
    background: "#1a1a1a",
    border: "1px solid #333",
    borderRadius: "6px",
    padding: "10px 12px",
    fontSize: "0.88rem",
    color: "#ccc",
    lineHeight: "1.5",
  };

  const badgeStyle = {
    display: "inline-block",
    background: "#ffd600",
    color: "#000",
    fontWeight: "bold",
    fontSize: "0.7rem",
    borderRadius: "4px",
    padding: "2px 7px",
    marginLeft: "10px",
    verticalAlign: "middle",
    letterSpacing: "0.5px",
  };

  const storeButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    borderRadius: "6px",
    border: "1px solid #555",
    background: "#1a1a1a",
    color: "#ccc",
    fontSize: "0.85rem",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "none",
    margin: "4px",
  };

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "20px 20px 40px",
        textAlign: "center",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "white",
        borderRadius: "8px",
        color: "white",
        backgroundColor: "black",
      }}
    >
      {/* Hero */}
      <h1 style={{ fontSize: "2.6rem", marginBottom: "8px", marginTop: "10px", color: "#ffd600" }}>
        Keno Analyzer
      </h1>
      <h2 style={{ fontSize: "1.3rem", marginBottom: "6px", marginTop: "0", color: "#ccc", fontWeight: 400 }}>
        A purpose-built simulator, session tracker, and strategy optimizer for 20-card keno.
      </h2>
      <p style={{ fontSize: "1.0rem", color: "#888", margin: "0 auto 28px", maxWidth: "620px" }}>
        Designed for players who want to understand their play — not guess at it.
      </p>

      {/* Screenshot */}
      <img
        src={process.env.PUBLIC_URL + "/keno_analyzer_001.png"}
        alt="Keno Analyzer Screenshot"
        style={{
          width: "100%",
          maxWidth: "760px",
          height: "auto",
          borderRadius: "8px",
          border: "3px solid #444",
          display: "block",
          margin: "0 auto 40px",
        }}
      />

      {/* Two product cards */}
      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "40px", textAlign: "left" }}>

        {/* Analyzer card */}
        <div style={productCardStyle}>
          <h3 style={{ fontSize: "1.3rem", color: "#ffd600", marginTop: 0, marginBottom: "10px" }}>
            🃏 Keno Analyzer
          </h3>
          <p style={{ fontSize: "0.95rem", color: "#bbb", lineHeight: "1.6", marginBottom: "14px" }}>
            Simulate single games or full multi-game sessions with up to 20 cards. Track hits,
            payouts, return%, and EV% per card — across any combination of spot sizes and bets.
          </p>
          <div style={featureGridStyle}>
            {["20-Card format", "Custom paytables", "Per-card analysis", "Session tracking", "Save & load configs", "Spot-size filtering", "Adjustable sim speed"].map(f => (
              <div key={f} style={featureChipStyle}>✓ {f}</div>
            ))}
          </div>
        </div>

        {/* Optimizer card */}
        <div style={{ ...productCardStyle, borderColor: "#ffd60055" }}>
          <h3 style={{ fontSize: "1.3rem", color: "#ffd600", marginTop: 0, marginBottom: "10px" }}>
            ⚙️ Keno Optimizer <span style={badgeStyle}>NEW</span>
          </h3>
          <p style={{ fontSize: "0.95rem", color: "#bbb", lineHeight: "1.6", marginBottom: "14px" }}>
            The Keno Optimizer mathematically searches thousands of card
            configurations and instantly generates fully optimized cards with your desires spot size, 
            ensuring no duplicates and Optimum spread, maximizing your coverage within your chosen numbers.
          </p>
          <div style={featureGridStyle}>
            {["Smart exhaustive search", "EV maximization", "Results in seconds", "Built into this site", "Standalone mobile app", "Use it at the casino"].map(f => (
              <div key={f} style={featureChipStyle}>✓ {f}</div>
            ))}
          </div>
          {/* Mobile app callout */}
          <div style={{ marginTop: "18px", paddingTop: "14px", borderTop: "1px solid #333", textAlign: "center" }}>
            <a
              href="https://kenooptimizer.com"
              target="_blank"
              rel="noreferrer"
              style={{ display: "inline-block", color: "#ffd600", fontWeight: "700", fontSize: "0.95rem", marginBottom: "10px", textDecoration: "none", letterSpacing: "0.3px" }}
            >
              kenooptimizer.com ↗
            </a>
            <p style={{ color: "#aaa", fontSize: "0.85rem", margin: "0 0 8px" }}>
              Mobile app — currently in closed testing:
            </p>
            <button type="button" style={storeButtonStyle}>🍎 TestFlight (iOS)</button>
            <button type="button" style={storeButtonStyle}>▶ Google Play (Beta)</button>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ marginTop: "10px", marginBottom: "10px" }}>
        <p style={{ fontSize: "1.05rem", color: "#ccc", marginBottom: "18px" }}>
          Join our community of keno players and start analyzing your sessions today.
        </p>
        <button
          className="home-cta-btn join"
          style={{ marginRight: "12px" }}
          onClick={() => (window.location.href = "/join")}
        >
          Join Free
        </button>
        <button
          className="home-cta-btn login"
          onClick={() => (window.location.href = "/login")}
        >
          Log In
        </button>
      </div>
    </div>
  );
}